import { Button, Modal, Table, Tabs } from "antd";

const { TabPane } = Tabs;

const CertificateSummaryModal = ({
    summaryModalProps: {
        generationSummary,
        isSummaryModalVisible,
        setIsSummaryModalVisible,
        setGenerationSummary,
        handleGenerate,
    },
}) => {
    const handleRetry = () => {
        handleGenerate(generationSummary.failed);
        setGenerationSummary({ success: [], failed: [], skipped: [] });
        setIsSummaryModalVisible(false);
    };

    const tableStyle = { overflowY: "auto", maxHeight: 400 };
    const modalBodyStyle = { padding: 0, maxHeight: 500, overflow: "hidden" };

    const tabConfig = [
        {
            key: "success",
            label: `✅ Successful (${generationSummary.success.length})`,
            data: generationSummary.success,
            columns: [
                { title: "Name", dataIndex: "fullName", key: "fullName" },
                { title: "Email", dataIndex: "email", key: "email" },
            ],
        },
        {
            key: "skipped",
            label: `⚠️ Skipped (${generationSummary.skipped.length})`,
            data: generationSummary.skipped,
            columns: [
                { title: "Name", dataIndex: "fullName", key: "fullName" },
                { title: "Email", dataIndex: "email", key: "email" },
            ],
        },
        {
            key: "failed",
            label: `❌ Failed (${generationSummary.failed.length})`,
            data: generationSummary.failed,
            columns: [
                { title: "Name", dataIndex: "fullName", key: "fullName", width: 200 },
                { title: "Email", dataIndex: "email", key: "email", width: 300 },
                { title: "Reason", dataIndex: "reason", key: "reason" },
            ],
        },
    ];

    return (
        <Modal
            title="Certificate Generation Summary"
            open={isSummaryModalVisible}
            onCancel={() => setIsSummaryModalVisible(false)}
            width={900}
            bodyStyle={modalBodyStyle}
            footer={[
                <Button key="close" onClick={() => setIsSummaryModalVisible(false)}>
                    Close
                </Button>,
                generationSummary.failed.length > 0 && (
                    <Button key="retry" type="primary" onClick={handleRetry}>
                        Regenerate All Failed
                    </Button>
                ),
            ]}
        >
            <Tabs defaultActiveKey="success" style={{ padding: 16 }}>
                {tabConfig.map(({ key, label, data, columns }) => (
                    <TabPane tab={label} key={key}>
                        <div style={tableStyle}>
                            <Table
                                columns={columns}
                                dataSource={data}
                                rowKey="email"
                                pagination={false}
                                scroll={{ x: "100%" }}
                            />
                        </div>
                    </TabPane>
                ))}
            </Tabs>
        </Modal>
    );
};

export default CertificateSummaryModal;